<template>
    <div class="detail-year-average-price">
        <van-nav-bar
            title="价"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
            @click-right="showFilterPop = true"
        >
            <template #title>
                <img class="nav_title" src="../../../assets/images/leadingCockpit/jia_nav.png">
            </template>
            <template #right>
                <img class="shaixuan" src="../../../assets/images/leadingCockpit/shaixuan.png">
            </template>
        </van-nav-bar>
        <div class="container-wrapper">
            <filterConditions
                :show-filter-pop.sync="showFilterPop"
                :date="date"
                @sureBack="sureBack"
            ></filterConditions>
            <div class="data-box">
                <div class="data-item">
                    <div class="name">
                        当月售价(元/方)：
                        <span class="num c1">{{ monthPrice }}</span>
                    </div>
                </div>
                <div class="data-item">
                    <div class="name">
                        年度均价(元/方)：
                        <span class="num c2">{{ yearAvgPrice }}</span>
                    </div>
                </div>
            </div>
            <div class="charts-panel">
                <div class="title">
                    综合销售价格
                </div>
                <div id="charts1" class="charts-box">
                </div>
            </div>
            <div class="bg-line"></div>
            <div class="charts-panel">
                <div class="title">
                    c30销售价格
                </div>
                <div id="charts2" class="charts-box">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import filterConditions from './filterConditions/index';
export default {
    name: 'detail-year-average-price',
    components: { filterConditions },
    data() {
        return {
            showFilterPop: false,
            filterParams: {},
            date: {
                startDate: '',
                endDate: '',
            },
            monthPrice: 0, // 当月售价
            yearAvgPrice: 0, // 年度均价
            prevYearAvgPrice: 0, // 上年均价
            totalDataList: [], // 综合销售价格列表
            prevTotalDataList: [], // 去年综合销售价格列表

            c30yearAvgPrice: 0, // 年度均价
            c30prevYearAvgPrice: 0, // 上年均价
            c30totalDataList: [], // 综合销售价格列表
            c30prevTotalDataList: [], // 去年综合销售价格列表
        };
    },
    created() {
        // 设置时间默认值 默认当月
        this.date.startDate = this.$route.params.startDate;
        this.date.endDate = this.$route.params.endDate;
        this.filterParams = Object.assign({}, this.date);
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            const data = await this.getTotalPrice();
            this.yearAvgPrice = data.price_year;
            this.prevYearAvgPrice = data.price_lastyear;
            this.monthPrice = data.list[data.list.length - 1].price;
            this.totalDataList = data.list;
            this.prevTotalDataList = data.list_last;
            this.initChart1();
            const c30Data = await this.getC30Price();
            this.c30yearAvgPrice = c30Data.price_year;
            this.c30prevYearAvgPrice = c30Data.price_lastyear;
            this.c30totalDataList = c30Data.list;
            this.c30prevTotalDataList = c30Data.list_last;
            this.initChart2();
        },
        // 确认选择时间
        startPickerConfirmData(val) {
            if (val >= this.endTimeValue) {
                this.$toast('开始时间不能大于结束时间！');
                return;
            }
            this.baseData.startTime = this.formatDate(val);
            this.getData();
            this.startPickerShow = false;
        },
        // 确认选择时间
        endPickerConfirmData(val) {
            if (val <= this.startTimeValue) {
                this.$toast('截止时间不能小于开始时间！');
                return;
            }
            this.baseData.endTime = this.formatDate(val);
            this.getData();
            this.endPickerShow = false;
        },
        sureBack(pamams) {
            this.filterParams = pamams;
            this.getData();
        },
        // 综合销售价格数据
        initChart1() {
            const myChart = this.$echarts.init(document.getElementById('charts1'));
            /** **test**********/
            const legendData = ['本年每月价格', '本年均价', '上年每月价格', '上年均价'];
            const xdata = [];

            const ydata = [
                {
                    name: '本年每月价格',
                    colors: ['#4EA97E', '#DCC94C'],
                    type: 'solid',
                    symbol: 'emptyCircle',
                    data: [],
                },
                {
                    name: '本年均价',
                    colors: ['#D7C84E', '#46A67D'],
                    type: 'dashed',
                    symbol: 'none',
                    data: [],
                },
                {
                    name: '上年每月价格',
                    colors: ['#F57D51', '#F94E4D'],
                    type: 'solid',
                    symbol: 'emptyCircle',
                    data: [],
                },
                {
                    name: '上年均价',
                    colors: ['#F57D51', '#F94E4D'],
                    type: 'dashed',
                    symbol: 'none',
                    data: [],
                },
            ];
            this.totalDataList.forEach((item, index) => {
                xdata.push(item.month_dim + '月');
                ydata[0].data.push(item.price); // 本年每月价格
                ydata[1].data.push(this.yearAvgPrice); // 本年均价
                ydata[2].data.push(this.prevTotalDataList[index].price); // 上年每月价格
                ydata[3].data.push(this.prevYearAvgPrice); // 上年均价
            });
            /** **test**********/
            this.drawLine(myChart, { legendData, xdata, ydata });

        },
        initChart2() {
            const myChart = this.$echarts.init(document.getElementById('charts2'));
            /** **test**********/
            const legendData = ['本年每月价格', '本年均价', '上年每月价格', '上年均价'];
            const xdata = [];
            const ydata = [
                {
                    name: '本年每月价格',
                    colors: ['#01C8FE', '#076DFD'],
                    type: 'solid',
                    symbol: 'emptyCircle',
                    data: [],
                },
                {
                    name: '本年均价',
                    colors: ['#01C8FE', '#076DFD'],
                    type: 'dashed',
                    symbol: 'none',
                    data: [],
                },
                {
                    name: '上年每月价格',
                    colors: ['#FCEF20', '#FEBD29'],
                    type: 'solid',
                    symbol: 'emptyCircle',
                    data: [],
                },
                {
                    name: '上年均价',
                    colors: ['#FCEF20', '#FEBD29'],
                    type: 'dashed',
                    symbol: 'none',
                    data: [],
                },
            ];
            this.c30totalDataList.forEach((item, index) => {
                xdata.push(item.month_dim + '月');
                ydata[0].data.push(item.price); // 本年每月价格
                ydata[1].data.push(this.c30yearAvgPrice); // 本年均价
                ydata[2].data.push(this.c30prevTotalDataList[index].price); // 上年每月价格
                ydata[3].data.push(this.c30prevYearAvgPrice); // 上年均价
            });
            /** **test**********/
            this.drawLine(myChart, { legendData, xdata, ydata });

        },
        // 划线
        drawLine(myChart, { legendData, xdata, ydata }) {
            const newOption = {
                title: {
                    text: '单位（万方）',
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                },
                animationEasing: 'elasticOut',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        label: {
                            show: true,
                        },
                    },
                },
                legend: {
                    width: 173,
                    right: 15,
                    itemWidth: 12,
                    itemHeight: 10,
                    data: legendData,
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                },
                grid: {
                    left: 40,
                    top: 50,
                    right: 10,
                    bottom: 20,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    data: xdata,
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        //	margin:15,
                        textStyle: {
                            color: 'rgba(255,255,255,0.5)',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 10,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#D8D8D8',
                            opacity: 0.3,
                        },
                    },
                },
                yAxis: [
                    {
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                            //	margin:15,
                            textStyle: {
                                color: 'rgba(255,255,255,0.5)',
                                fontStyle: 'normal',
                                fontFamily: '微软雅黑',
                                fontSize: 10,
                            },
                        },
                        axisTick: {
                            // 坐标轴刻度相关设置。
                            show: false,
                        },
                        axisLine: {
                            // 坐标轴轴线相关设置
                            lineStyle: {
                                color: '#D8D8D8',
                                opacity: 0.3,
                            },
                        },
                        splitLine: {
                            // 坐标轴在 grid 区域中的分隔线。
                            show: true,
                            lineStyle: {
                                color: '#fff',
                                opacity: 0.1,
                                type: 'dashed',
                            },
                        },
                    },
                ],
                series: [],
            };
            ydata.forEach(item => {
                newOption.series.push(
                    {
                        name: item.name,
                        type: 'line',
                        symbol: item.symbol,
                        barMaxWidth: 15,
                        silent: true,
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: item.colors[0] },
                                        { offset: 1, color: item.colors[1] },
                                    ]
                                ),
                                label: {
                                    show: false,
                                    position: 'top',
                                    textStyle: {
                                        color: '#DCC229',
                                        fontSize: 10,
                                    },
                                },
                            },
                        },
                        lineStyle: {
                            type: item.type,
                            width: (() => {
                                if (item.type === 'dashed') {
                                    return 1;
                                }
                                return 2;
                            })(),
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    { offset: 0, color: item.colors[0] },
                                    { offset: 1, color: item.colors[1] },
                                ],
                            },
                            opacity: (() => {
                                if (item.type === 'dashed') {
                                    return 0;
                                }
                                return 0.1;
                            })(),
                        },
                        z: 1,
                        animationEasing: 'elasticOut',
                        data: item.data,
                    }
                );
            });
            myChart.setOption(newOption, true );
        },
        // 获取综合销售价格
        getTotalPrice(cpbh) {
            const url = '/interfaceApi/report/leadercockpit/price_data';
            const data = this.filterParams;
            if (cpbh) {
                data.cpbh = cpbh;
            } else {
                data.cpbh = '';
            }
            return this.$axios.post(url, data);
        },
        // c30销售价格
        getC30Price() {
            return this.getTotalPrice('c30');
        },
        // 时间格式处理
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转页面
        to(path) {
            this.$router.isBack = 2;
            this.$router.push({ name: path });
        },
    },
};
</script>
<style scoped lang="stylus">
    .detail-year-average-price
        background url('../../../assets/images/leadingCockpit/bg.png') #0E1C31
        background-size 100%
        padding-bottom 20rpx;
        .van-nav-bar
            background #001F4C !important;
            .shaixuan
                width 18rpx;
        .nav_title
            margin-top 10rpx
            width 52rpx;
        .container-wrapper
            height calc(100% - 20rpx)
            overflow-y auto
        .bg-line
            height 15rpx;
            background rgba(0,0,0,0.5);
        .filterConditions
            display flex
            width 94%;
            height 40rpx
            padding 15rpx 10rpx
            margin: 13rpx auto 0;
            background url("../../../assets/images/leadingCockpit/bg_secondary_page_1.png") no-repeat center
            background-size 100%
            justify-content center
            align-items center
            .filter-pop
                width: 300rpx;
                height: 100vh;
                background: #0E1D33;
                box-shadow: -2rpx 0px 10rpx 0px rgba(0, 0, 0, 0.7);
                .head
                    width: 100%;
                    height: 64rpx;
                    background: #072653;
                    display flex
                    justify-content center
                    align-items center
                    position relative;
                    .name
                        font-size: 18rpx;
                        color: #fff;
                    .close-filter-pop
                        position absolute
                        top 24rpx
                        right 16rpx
                        font-size: 14rpx;
                        color: rgba(255,255,255,0.6);
                .filter-contain
                     height calc(100vh - 64rpx)
                     overflow-y auto
                    .filter-box
                        padding 15rpx;
                        h1
                            font-size 14px;
                            color #fff;
                        ul
                            display flex
                            flex-wrap wrap
                            li
                                display flex
                                justify-content center
                                align-items center
                                margin 4rpx 3rpx;
                                width: 84rpx;
                                height: 30rpx;
                                background: #162945;
                                border-radius: 4rpx;
                                border: 1px solid #1F375A;
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                                font-size 14rpx
                                color: #5695F1;
                                &.active
                                    background: linear-gradient(135deg, #3A96FE 0%, #40B6FF 100%);
                                    color #fff;
            .line
                width: 20rpx;
                height: 2px;
                background: rgba(255, 255, 255, 0.2);
            .time
                width 80rpx
                height 30rpx
                line-height 28rpx
                margin 0 5rpx
                position relative
                input
                    width 130rpx
                    height 30rpx
                    border none
                    text-indent 30rpx
                    background: transparent;
                    font-size 14rpx;
                    color:#fff;
                    font-family: Technology-Regular, Technology;
                &:before
                    line-height 30rpx
                    font-size 16rpx
                    color #0096F8
                    position absolute
                    left 5rpx
        .data-box
            display flex
            justify-content space-between
            padding 15rpx;
            .data-item
                width 165rpx
                height: 40rpx;
                background: #12243D;
                border: 1px solid #27436C;
                .name
                    height 100%
                    font-size 12rpx;
                    color:#fff;
                    opacity 0.7;
                    padding-left 12rpx;
                    display flex
                    align-items center
                    .num
                        font-size: 18px;
                        font-family: Technology-Regular, Technology;
                    .c1
                        color: #03B0FE;
                    .c2
                        color: #FDDC24;
    .charts-panel
            padding 15rpx;
            .title
                font-size 16rpx;
                color:#fff;
            .charts-box
                padding-top 20rpx;
                height 180rpx;
</style>
